const colors = {
  blue: '#1870DC',
  green: '#58D777',
  orange: '#f0af03',
  red: '#F45722',
  purple: '#474D84',
  dark: '#040620',
  teal: '#14d3d3',
  pink: '#e671b8',
  gray: '#d6dee5',
  default: '#595d78',
  textColor: '#b4b5bf',
  gridLineColor: '#040620'
};

export default {
  colors: {
    ...colors,
    white: "#fff"
  },
};
